'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var _jsx = require('@babel/runtime/helpers/jsx');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var classNames = require('classnames');
var floatingMenu = require('@andes/floating-menu');
var context = require('@andes/context');
var warning = require('@andes/common/build/utils/warning');
var ChevronDown12 = require('@andes/icons/ChevronDown12');
require('@andes/common/build/utils/includes');
var ChevronDown20 = require('@andes/icons/ChevronDown20');
var FeedbackNegative12 = require('@andes/icons/FeedbackNegative12');
var tag = require('@andes/tag');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
var ChevronDown12__default = /*#__PURE__*/_interopDefaultLegacy(ChevronDown12);
var ChevronDown20__default = /*#__PURE__*/_interopDefaultLegacy(ChevronDown20);
var FeedbackNegative12__default = /*#__PURE__*/_interopDefaultLegacy(FeedbackNegative12);
const MODIFIER_ERROR = 'error';
const TYPE_STANDALONE = 'standalone';
const TYPE_NATIVE = 'native';
const DEPRECATED_SIZE_DEFAULT = 'default';
const DEPRECATED_SIZE_COMPACT = 'compact';
const SIZE_SMALL = 'small';
const SIZE_LARGE = 'large';
const MENU_ALIGNMENT_CENTER = 'center';
const MENU_BOTTOM_OFFSET_Y = 6;
const MENU_STANDALONE_OFFSET_X = -9;
const MENU_BOUNDARIES = 8;
const DROPDOWN_ARROW_SPACING = 100;
const MAX_TAG_LIMIT = 1000;
const TAG_SMALL_LETTER_WIDTH = 8;
const TAG_SMALL_OFFSET = 30;
const namespace = 'andes-dropdown';
const triggerNamespace = "".concat(namespace, "__trigger");
const formNamespace = 'andes-form-control';
const floatingMenuNamespace = 'andes-floating-menu';
const listNamespace = 'andes-list';
const listItemClassName = "".concat(listNamespace, "__item");
const getItemToFocus = menu => {
  const optionsList = Array.prototype.slice.call(menu.querySelectorAll(".".concat(listItemClassName)));
  if (optionsList.length) {
    let focusableOption = optionsList.find(option => option.tabIndex === 0);
    if (!focusableOption) {
      focusableOption = optionsList.find(option => option.className.indexOf(".".concat(listItemClassName, "--selected")) !== -1);
    }
    if (!focusableOption) {
      [focusableOption] = optionsList;
    }
    return focusableOption;
  }
  return null;
};
const TRIGGER_MARGIN = 2;
const getMenuOffset = _ref => {
  let {
    centeredMenu,
    mainContainerRef
  } = _ref;
  if (!centeredMenu) {
    return {
      offset: undefined,
      calculated: true
    };
  }
  const main = mainContainerRef.current;
  const floatingMenu = main === null || main === void 0 ? void 0 : main.querySelector('ul');
  const scrollableContainer = main === null || main === void 0 ? void 0 : main.querySelector('.andes-card');
  const trigger = main === null || main === void 0 ? void 0 : main.querySelector(".".concat(triggerNamespace));
  if (floatingMenu && trigger) {
    const itemToCenter = getItemToFocus(floatingMenu);
    if (itemToCenter) {
      const itemHeight = itemToCenter.offsetHeight;
      const distance = itemToCenter.offsetTop - scrollableContainer.scrollTop;
      const offset = -itemHeight - distance - TRIGGER_MARGIN;
      return {
        offset,
        calculated: true
      };
    }
  }
  return {
    offset: undefined,
    calculated: false
  };
};
var getMenuOffset$1 = getMenuOffset;
const WARNING_DUPLICATED_VALUE = "value {0} already exists.\nPlease, use a different value for each <DropdownItem>";
const DROPDOWN_ITEM_DISPLAY_NAME = 'DropdownItem';
const DROPDOWN_GROUP_DISPLAY_NAME = 'DropdownGroup';
const DROPDOWN_NATIVE_DISPLAY_NAME = 'DropdownNative';
const DROPDOWN_NATIVE_ITEM_DISPLAY_NAME = 'DropdownNativeItem';
const getItemsPrimary = _ref => {
  var _firstOption$type;
  let {
    children
  } = _ref;
  const firstOption = Array.isArray(children) ? children[0] : children;
  const firstOptionType = firstOption === null || firstOption === void 0 || (_firstOption$type = firstOption.type) === null || _firstOption$type === void 0 ? void 0 : _firstOption$type.displayName;
  const reference = {};
  const setPrimaryReference = item => {
    const {
      value: itemValue,
      primary: itemPrimary,
      title
    } = item.props;
    warning__default["default"](!reference[itemValue], WARNING_DUPLICATED_VALUE.replace('{0}', itemValue));
    reference[itemValue] = title || itemPrimary;
  };
  if (firstOptionType === DROPDOWN_ITEM_DISPLAY_NAME) {
    React.Children.forEach(children, setPrimaryReference);
  }
  if (firstOptionType === DROPDOWN_GROUP_DISPLAY_NAME) {
    React.Children.forEach(children, group => {
      React.Children.forEach(group.props.children, setPrimaryReference);
    });
  }
  return reference;
};
var getItemsPrimary$1 = getItemsPrimary;
const getTriggerDisplayValues = _ref => {
  let {
    values,
    multiple,
    itemsPrimaryReference
  } = _ref;
  let displayValues;
  if (typeof values === 'undefined') return displayValues;
  if (Array.isArray(values)) {
    displayValues = values.map(selectedValue => itemsPrimaryReference[selectedValue]);
  } else {
    displayValues = itemsPrimaryReference[values];
  }
  if (displayValues && multiple && !Array.isArray(displayValues)) {
    displayValues = [displayValues];
  }
  return displayValues;
};
var getTriggerDisplayValues$1 = getTriggerDisplayValues;
const _excluded$4 = ["aria-label", "aria-labelledby", "children", "defaultValue", "disabled", "helper", "label", "menuAlignment", "modifier", "multiple", "onChange", "onClose", "onOpen", "open", "placeholder", "primary", "searchConfig", "srLabel", "value"];
const useDropdown = (mainContainerRef, _ref) => {
  let {
      'aria-label': willdeprecate$ariaLabel,
      'aria-labelledby': willdeprecate$ariaLabelledby,
      children,
      defaultValue,
      disabled,
      helper,
      label,
      menuAlignment,
      modifier,
      multiple,
      onChange,
      onClose,
      onOpen,
      open,
      placeholder,
      primary,
      searchConfig,
      srLabel,
      value
    } = _ref,
    other = _objectWithoutProperties__default["default"](_ref, _excluded$4);
  const isUncontrolled = React.useMemo(() => value === undefined, []);
  const isOpenUncontrolled = React.useMemo(() => open === undefined, []);
  const centeredMenu = React.useMemo(() => {
    if (multiple || searchConfig) return false;
    return menuAlignment === MENU_ALIGNMENT_CENTER;
  }, [menuAlignment, multiple, searchConfig]);
  const itemsPrimaryReference = React.useMemo(() => {
    if (!children) return {};
    return getItemsPrimary$1({
      children
    });
  }, [children]);
  const {
    device
  } = React.useContext(context.AndesContext);
  const isMobile = device === null || device === void 0 ? void 0 : device.mobile;
  const [currentValues, setCurrentValues] = React.useState(value || defaultValue);
  const [currentDisplayValues, setCurrentDisplayValues] = React.useState(getTriggerDisplayValues$1({
    values: currentValues,
    multiple,
    itemsPrimaryReference
  }));
  const [isMenuVisible, setIsMenuVisible] = React.useState(false);
  const offsetInitialValue = centeredMenu ? 0 : MENU_BOTTOM_OFFSET_Y;
  const [menuOffset, setMenuOffset] = React.useState(offsetInitialValue);
  const [menuOffsetCalculated, setMenuOffsetCalculated] = React.useState(false);
  const [placement, setPlacement] = React.useState(undefined);
  const handleOnChange = (event, values) => {
    if (isUncontrolled) {
      setCurrentValues(values);
      setCurrentDisplayValues(getTriggerDisplayValues$1({
        values,
        multiple,
        itemsPrimaryReference
      }));
    }
    if (typeof onChange === 'function') {
      event.target.value = values;
      onChange(event, values);
    }
  };
  const handleOpen = event => {
    if (isOpenUncontrolled) {
      setIsMenuVisible(true);
      setTimeout(() => {
        const {
          offset,
          calculated
        } = getMenuOffset$1({
          centeredMenu,
          mainContainerRef
        });
        setMenuOffset(offset);
        setMenuOffsetCalculated(calculated);
      }, 0);
    }
    if (typeof onOpen === 'function') onOpen(event);
  };
  const handleClose = () => {
    if (isOpenUncontrolled) {
      setIsMenuVisible(false);
      if (centeredMenu) {
        setMenuOffset(0);
        setMenuOffsetCalculated(false);
      }
    }
    if (typeof onClose === 'function') onClose();
  };
  React.useEffect(() => {
    if (!isUncontrolled) {
      setCurrentValues(value);
      setCurrentDisplayValues(getTriggerDisplayValues$1({
        values: value,
        multiple,
        itemsPrimaryReference
      }));
    }
  }, [value]);
  React.useEffect(() => {
    if (!isOpenUncontrolled) {
      if (open) {
        setIsMenuVisible(true);
        setTimeout(() => {
          const {
            offset,
            calculated
          } = getMenuOffset$1({
            centeredMenu,
            mainContainerRef
          });
          setMenuOffset(offset);
          setMenuOffsetCalculated(calculated);
        }, 0);
      } else {
        setIsMenuVisible(false);
        if (centeredMenu) {
          setMenuOffset(0);
          setMenuOffsetCalculated(false);
        }
      }
    }
  }, [open, isOpenUncontrolled, centeredMenu, mainContainerRef]);
  const getValuesAsArray = () => {
    if (Array.isArray(currentValues)) return currentValues;
    if (typeof currentValues === 'string' && !!currentValues || typeof currentValues === 'number') return [currentValues];
    return [];
  };
  const getPopperOptions = () => {
    if (menuAlignment === 'center' || isMobile && searchConfig) {
      const fallbackPlacements = isMobile && searchConfig ? ['top', 'bottom'] : [];
      return {
        modifiers: [{
          name: 'flip',
          options: {
            fallbackPlacements
          }
        }]
      };
    }
    return {};
  };
  const menuProps = _objectSpread__default["default"](_objectSpread__default["default"]({}, other), {}, {
    menuOffsetCalculated,
    menuOffsetY: menuOffset,
    onChange: handleOnChange,
    onClose: handleClose,
    onOpen: handleOpen,
    popperOptions: getPopperOptions(),
    onMount: instance => {
      var _instance$popperInsta;
      return setPlacement((_instance$popperInsta = instance.popperInstance) === null || _instance$popperInsta === void 0 || (_instance$popperInsta = _instance$popperInsta.state) === null || _instance$popperInsta === void 0 ? void 0 : _instance$popperInsta.placement);
    },
    placement: placement || 'bottom'
  });
  return {
    currentDisplayValues,
    currentValues: getValuesAsArray(),
    isMenuVisible,
    menuProps
  };
};
var useDropdown$1 = useDropdown;
var _ChevronDown$2;
const StandaloneArrow = _ref => {
  let {
    namespace
  } = _ref;
  return /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(namespace, "__standalone-arrow"),
    "aria-hidden": true
  }, void 0, _ChevronDown$2 || (_ChevronDown$2 = /*#__PURE__*/_jsx__default["default"](ChevronDown12__default["default"], {})));
};
var StandaloneArrow$1 = StandaloneArrow;
const computeSearchProps = _ref => {
  let {
    search: searchProps,
    defaultSearchValue: defaultSearchValueProp,
    searchPlaceholder: searchPlaceholderProp,
    onSearchChange: onSearchChangeProp,
    filterCondition: filterConditionProp
  } = _ref;
  if (!searchProps) return undefined;
  if (typeof searchProps === 'boolean') {
    return {
      defaultValue: defaultSearchValueProp,
      placeholder: searchPlaceholderProp,
      onChange: onSearchChangeProp,
      filterCondition: filterConditionProp,
      search: true
    };
  }
  const {
    defaultValue: defaultValueConfig,
    placeholder: placeholderConfig,
    onChange: onChangeConfig,
    filterCondition: filterConditionConfig
  } = searchProps;
  return {
    defaultValue: defaultValueConfig || defaultSearchValueProp,
    placeholder: placeholderConfig || searchPlaceholderProp,
    onChange: onChangeConfig || onSearchChangeProp,
    filterCondition: filterConditionConfig || filterConditionProp,
    search: true
  };
};
var computeSearchProps$1 = computeSearchProps;
const computeValueType = _ref => {
  let {
    defaultValueProp,
    valueProp
  } = _ref;
  const computeDefaultValue = typeof defaultValueProp === 'number' ? String(defaultValueProp) : defaultValueProp;
  const computeValue = typeof valueProp === 'number' ? String(valueProp) : valueProp;
  return {
    value: computeValue,
    defaultValue: computeDefaultValue
  };
};
var computeValueType$1 = computeValueType;
const computeSize = size => {
  switch (size) {
    case DEPRECATED_SIZE_COMPACT:
      return SIZE_SMALL;
    case DEPRECATED_SIZE_DEFAULT:
      return SIZE_LARGE;
    default:
      return size;
  }
};
var computeSize$1 = computeSize;
var _StandaloneArrow;
const _excluded$3 = ["menuOffsetCalculated", "menuOffsetY"];
const DropdownStandalone = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    'aria-label': willdeprecate$ariaLabel,
    allowUnselect = false,
    children,
    className,
    closable,
    defaultOpen,
    defaultSearchValue,
    defaultValue: defaultValueProp,
    disabled = false,
    filterCondition,
    id: idProp,
    label = '',
    menuAlignment = 'center',
    menuMaxHeight,
    multiple = false,
    onSearchChange,
    open,
    primary: willdeprecate$primary,
    search = false,
    searchPlaceholder,
    size = SIZE_LARGE,
    srLabel,
    value: valueProp,
    renderCustomTrigger
  } = props;
  const id = context.useId(idProp);
  const ownContainerRef = React.useRef(null);
  const containerRef = ref || ownContainerRef;
  const searchConfig = computeSearchProps$1({
    search,
    defaultSearchValue,
    onSearchChange,
    searchPlaceholder,
    filterCondition
  });
  const {
    value,
    defaultValue
  } = computeValueType$1({
    valueProp,
    defaultValueProp
  });
  const computedSize = computeSize$1(size);
  const defaultProps = {
    disabled,
    menuAlignment,
    multiple,
    search,
    size
  };
  const {
    menuProps,
    isMenuVisible,
    currentDisplayValues,
    currentValues
  } = useDropdown$1(containerRef, _objectSpread__default["default"](_objectSpread__default["default"](_objectSpread__default["default"]({}, props), defaultProps), {}, {
    id,
    searchConfig,
    value,
    defaultValue
  }));
  const getTriggerContent = updateTriggerContent => {
    let newTriggerContent = '';
    if (typeof currentDisplayValues === 'string') {
      newTriggerContent = currentDisplayValues;
    } else if (Array.isArray(currentDisplayValues) && currentDisplayValues.length === 1) {
      [newTriggerContent] = currentDisplayValues;
    }
    if (typeof renderCustomTrigger === 'function') {
      newTriggerContent = renderCustomTrigger(currentDisplayValues, currentValues);
    }
    if (typeof updateTriggerContent === 'function') updateTriggerContent(newTriggerContent);
    return newTriggerContent;
  };
  const [triggerContent, setTriggerContent] = React.useState(getTriggerContent());
  React.useEffect(() => {
    getTriggerContent(setTriggerContent);
  }, [currentDisplayValues]);
  React.useEffect(() => {
    if (willdeprecate$primary) {
      setTriggerContent(willdeprecate$primary);
    }
  }, [willdeprecate$primary]);
  const getMenuWidth = () => {
    const main = containerRef.current;
    const trigger = main === null || main === void 0 ? void 0 : main.getElementsByClassName(triggerNamespace)[0];
    if (trigger) {
      return {
        width: 'auto',
        minWidth: trigger.clientWidth + -MENU_STANDALONE_OFFSET_X
      };
    }
    return undefined;
  };
  const containerClassNames = classNames__default["default"](namespace, "".concat(namespace, "--standalone"), className, {
    ["".concat(namespace, "--open")]: isMenuVisible,
    ["".concat(namespace, "--").concat(computedSize)]: computedSize,
    ["".concat(formNamespace, "--disabled")]: disabled
  });
  const {
      menuOffsetCalculated,
      menuOffsetY
    } = menuProps,
    other = _objectWithoutProperties__default["default"](menuProps, _excluded$3);
  const trigger = /*#__PURE__*/_jsx__default["default"]("button", {
    "aria-label": willdeprecate$ariaLabel || srLabel,
    "aria-labelledby": !(willdeprecate$ariaLabel || srLabel) ? "".concat(id, "-label ").concat(id, "-display-values") : undefined,
    className: triggerNamespace,
    disabled: disabled,
    type: "button",
    id: "".concat(id, "-trigger")
  }, void 0, label && /*#__PURE__*/_jsx__default["default"]("span", {
    className: "".concat(triggerContent ? 'andes-visually-hidden' : "".concat(namespace, "__display-values")),
    id: "".concat(id, "-label")
  }, void 0, label), triggerContent && /*#__PURE__*/_jsx__default["default"]("span", {
    className: "".concat(namespace, "__display-values"),
    id: "".concat(id, "-display-values")
  }, void 0, triggerContent), _StandaloneArrow || (_StandaloneArrow = /*#__PURE__*/_jsx__default["default"](StandaloneArrow$1, {
    namespace: namespace
  })));
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: menuProps.id,
    className: containerClassNames,
    ref: containerRef
  }, /*#__PURE__*/React__default["default"].createElement(floatingMenu.FloatingMenu, _extends__default["default"]({}, other, getMenuWidth(), {
    search: searchConfig,
    srLabel: srLabel || label || willdeprecate$ariaLabel,
    allowUnselect: allowUnselect,
    className: menuOffsetCalculated ? 'andes-floating-menu--show' : '',
    closable: closable,
    defaultOpen: defaultOpen,
    defaultValue: defaultValue,
    id: "".concat(menuProps.id, "-menu"),
    menuMaxHeight: menuMaxHeight,
    multiple: multiple,
    offset: [MENU_STANDALONE_OFFSET_X, menuOffsetY],
    open: open,
    placement: "bottom-start",
    trigger: trigger,
    type: "select",
    value: value
  }), children));
});
var DropdownStandalone$1 = DropdownStandalone;
const TagContent = _ref => {
  let {
    currentDisplayValues = [],
    currentValues = [],
    disabled = false,
    namespace = '',
    containerRef,
    id,
    onSelectionChange
  } = _ref;
  const currentDisplayValuesHasItems = Array.isArray(currentDisplayValues) && currentDisplayValues.length > 0;
  const tagLimitReachedRef = React.useRef(false);
  const [tagLimit, setTagLimit] = React.useState(MAX_TAG_LIMIT);
  const calculateTagLimit = () => {
    var _containerRef$current;
    const containerWidth = containerRef === null || containerRef === void 0 || (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth;
    let totalLength = 0;
    currentDisplayValues.forEach((currentLabel, labelIndex) => {
      const currentLabelLength = (currentLabel === null || currentLabel === void 0 ? void 0 : currentLabel.toString().length) * TAG_SMALL_LETTER_WIDTH + TAG_SMALL_OFFSET;
      if (totalLength + currentLabelLength + DROPDOWN_ARROW_SPACING > containerWidth) {
        if (!tagLimitReachedRef.current) {
          setTagLimit(labelIndex);
          tagLimitReachedRef.current = true;
        }
      } else {
        setTagLimit(MAX_TAG_LIMIT);
        tagLimitReachedRef.current = false;
      }
      totalLength += currentLabelLength;
    });
  };
  React.useEffect(() => {
    if (currentDisplayValuesHasItems) {
      calculateTagLimit();
    }
  }, [currentDisplayValues]);
  if (!currentDisplayValuesHasItems) return null;
  return /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(namespace, "__display-container"),
    id: "".concat(id, "-display-values")
  }, void 0, /*#__PURE__*/_jsx__default["default"](tag.TagCollapsed, {
    limit: tagLimit,
    disabled: disabled,
    id: "".concat(id, "-dropdown-tag-content")
  }, void 0, currentDisplayValues.map((displayValue, index) => /*#__PURE__*/_jsx__default["default"](tag.Tag, {
    id: "".concat(id, "-tag-").concat(index),
    className: "".concat(namespace, "__display-values"),
    component: "div",
    size: "small",
    disabled: disabled,
    label: displayValue,
    onClose: disabled ? undefined : event => onSelectionChange(event, currentValues.filter((_, i) => i !== index)),
    onClick: event => event.stopPropagation()
  }, "".concat(displayValue, "_").concat(index)))));
};
var TagContent$1 = TagContent;
const _excluded$2 = ["menuOffsetCalculated", "menuOffsetY"];
var _FeedbackNegative, _ChevronDown$1;
const DropdownForm = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    'aria-label': willdeprecate$ariaLabel,
    allowUnselect = false,
    children,
    className,
    defaultOpen = false,
    defaultSearchValue,
    defaultValue: defaultValueProp,
    disabled = false,
    filterCondition,
    id: idProp,
    label = '',
    menuAlignment = 'center',
    menuMaxHeight,
    modifier,
    multiple = false,
    onSearchChange,
    open,
    placeholder = '',
    primary: willdeprecate$primary,
    renderCustomTrigger,
    search = false,
    searchPlaceholder,
    srLabel,
    value: valueProp
  } = props;
  const id = context.useId(idProp);
  const ownContainerRef = React.useRef(null);
  const containerRef = ref || ownContainerRef;
  const searchConfig = computeSearchProps$1({
    search,
    defaultSearchValue,
    onSearchChange,
    searchPlaceholder,
    filterCondition
  });
  const {
    value,
    defaultValue
  } = computeValueType$1({
    valueProp,
    defaultValueProp
  });
  const defaultProps = {
    disabled,
    multiple,
    menuAlignment,
    search
  };
  const {
    menuProps,
    isMenuVisible,
    currentDisplayValues,
    currentValues
  } = useDropdown$1(containerRef, _objectSpread__default["default"](_objectSpread__default["default"](_objectSpread__default["default"]({}, props), defaultProps), {}, {
    id,
    searchConfig,
    value,
    defaultValue
  }));
  const currentDisplayValuesHasItems = Array.isArray(currentDisplayValues) && currentDisplayValues.length > 0;
  const getTriggerContent = updateTriggerContent => {
    let newTriggerContent = null;
    if (!Array.isArray(currentDisplayValues) && currentDisplayValues) {
      newTriggerContent = /*#__PURE__*/_jsx__default["default"]("span", {
        className: "".concat(namespace, "__display-values"),
        id: "".concat(id, "-display-values")
      }, void 0, currentDisplayValues);
    } else if (currentDisplayValuesHasItems) {
      newTriggerContent = /*#__PURE__*/_jsx__default["default"]("span", {
        className: "".concat(namespace, "__display-values"),
        id: "".concat(id, "-display-values")
      }, void 0, [currentDisplayValues.join()]);
    } else if (placeholder || willdeprecate$primary) {
      newTriggerContent = /*#__PURE__*/_jsx__default["default"]("span", {
        className: "".concat(formNamespace, "__placeholder"),
        id: "".concat(id, "-display-values")
      }, void 0, placeholder || willdeprecate$primary);
    }
    if (typeof renderCustomTrigger === 'function') {
      newTriggerContent = renderCustomTrigger(currentDisplayValues, currentValues);
    }
    if (typeof updateTriggerContent === 'function') updateTriggerContent(newTriggerContent);
    return newTriggerContent;
  };
  const getTagTriggerContent = updateTriggerContent => {
    const newTagContent = /*#__PURE__*/_jsx__default["default"](TagContent$1, {
      currentDisplayValues: currentDisplayValues,
      currentValues: currentValues,
      disabled: disabled,
      namespace: namespace,
      containerRef: containerRef,
      onSelectionChange: menuProps.onChange,
      id: id
    });
    if (typeof updateTriggerContent === 'function') updateTriggerContent(newTagContent);
    return newTagContent;
  };
  const [triggerContent, setTriggerContent] = React.useState(getTriggerContent());
  const [tagTriggerContent, setTagTriggerContent] = React.useState(getTagTriggerContent());
  React.useEffect(() => {
    if (!multiple || !currentDisplayValuesHasItems) {
      getTriggerContent(setTriggerContent);
    }
    if (multiple) {
      getTagTriggerContent(setTagTriggerContent);
    }
  }, [currentDisplayValues, disabled]);
  React.useEffect(() => {
    if (willdeprecate$primary) {
      setTriggerContent(/*#__PURE__*/_jsx__default["default"]("span", {
        className: "".concat(namespace, "__display-values"),
        id: "".concat(id, "-display-values")
      }, void 0, willdeprecate$primary));
    }
  }, [id, willdeprecate$primary]);
  const getMessage = () => {
    const {
      helper
    } = props;
    if (helper && !disabled) {
      return /*#__PURE__*/_jsx__default["default"]("span", {
        className: "".concat(formNamespace, "__message"),
        id: "".concat(id, "-helper")
      }, void 0, modifier === MODIFIER_ERROR && /*#__PURE__*/_jsx__default["default"]("span", {
        className: "".concat(namespace, "__error-icon"),
        "aria-hidden": true,
        "data-testid": "error-feedback"
      }, void 0, _FeedbackNegative || (_FeedbackNegative = /*#__PURE__*/_jsx__default["default"](FeedbackNegative12__default["default"], {
        color: "white"
      }))), helper);
    }
    return null;
  };
  const getMenuWidth = () => {
    const main = containerRef.current;
    const trigger = main === null || main === void 0 ? void 0 : main.getElementsByClassName(triggerNamespace)[0];
    if (trigger) {
      return {
        width: trigger.clientWidth + MENU_BOUNDARIES
      };
    }
    return undefined;
  };
  const containerClassNames = classNames__default["default"](namespace, "".concat(namespace, "--form"), formNamespace, className, {
    ["".concat(namespace, "--open")]: isMenuVisible,
    ["".concat(namespace, "--multiple")]: multiple,
    ["".concat(namespace, "--bottom")]: menuAlignment === 'bottom' || search,
    ["".concat(formNamespace, "--error")]: modifier === MODIFIER_ERROR,
    ["".concat(formNamespace, "--disabled")]: disabled
  });
  const trigger = /*#__PURE__*/
  _jsx__default["default"]("button", {
    "aria-label": willdeprecate$ariaLabel || srLabel,
    "aria-labelledby": !(willdeprecate$ariaLabel || srLabel) ? "".concat(id, "-label ").concat(id, "-display-values") : undefined,
    "aria-describedby": getMessage() ? "".concat(id, "-helper") : undefined,
    "aria-invalid": modifier === MODIFIER_ERROR,
    className: triggerNamespace,
    disabled: disabled,
    type: "button",
    id: "".concat(id, "-trigger")
  }, void 0, (!multiple || !currentDisplayValuesHasItems) && triggerContent, /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(namespace, "__chevron"),
    "aria-hidden": true
  }, void 0, _ChevronDown$1 || (_ChevronDown$1 = /*#__PURE__*/_jsx__default["default"](ChevronDown20__default["default"], {}))));
  const {
      menuOffsetCalculated,
      menuOffsetY
    } = menuProps,
    other = _objectWithoutProperties__default["default"](menuProps, _excluded$2);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: containerClassNames,
    ref: containerRef,
    id: menuProps.id
  }, label && /*#__PURE__*/_jsx__default["default"]("span", {
    id: "".concat(id, "-label"),
    className: "".concat(formNamespace, "__label"),
    "aria-hidden": true
  }, void 0, label), /*#__PURE__*/React__default["default"].createElement(floatingMenu.FloatingMenu, _extends__default["default"]({}, other, getMenuWidth(), {
    search: searchConfig,
    srLabel: srLabel || label || willdeprecate$ariaLabel,
    allowUnselect: allowUnselect,
    className: menuOffsetCalculated ? "".concat(floatingMenuNamespace, "--show") : '',
    defaultOpen: defaultOpen,
    defaultValue: defaultValue,
    id: "".concat(menuProps.id, "-menu"),
    menuMaxHeight: menuMaxHeight,
    multiple: multiple,
    offset: [0, menuOffsetY],
    open: open,
    trigger: trigger,
    type: "select",
    value: multiple ? currentValues : value
  }), children), multiple && tagTriggerContent, getMessage());
});
var DropdownForm$1 = DropdownForm;
const Dropdown = /*#__PURE__*/function () {
  const Dropdown = /*#__PURE__*/React__default["default"].forwardRef((props, ref) => {
    const {
      multiple,
      type = TYPE_STANDALONE
    } = props;
    if (type === TYPE_STANDALONE && !multiple) return /*#__PURE__*/React__default["default"].createElement(DropdownStandalone$1, _extends__default["default"]({}, props, {
      ref: ref
    }));
    return /*#__PURE__*/React__default["default"].createElement(DropdownForm$1, _extends__default["default"]({}, props, {
      ref: ref
    }));
  });
  Dropdown.displayName = 'Dropdown';
  return Dropdown;
}();
var Dropdown$1 = Dropdown;
const DropdownNativeItem = _ref => {
  let {
    selected = false,
    disabled = false,
    primary,
    value,
    title
  } = _ref;
  return /*#__PURE__*/_jsx__default["default"]("option", {
    selected: selected || undefined,
    disabled: disabled,
    value: value
  }, void 0, title || primary);
};
DropdownNativeItem.displayName = DROPDOWN_NATIVE_ITEM_DISPLAY_NAME;
var DropdownNativeItem$1 = DropdownNativeItem;
const DropdownItem = /*#__PURE__*/function () {
  const DropdownItem = props => {
    const {
      type,
      title,
      description,
      rightContent,
      primary: _willdeprecate$primary,
      secondary: _willdeprecate$secondary,
      tertiary: _willdeprecate$tertiary
    } = props;
    if (type === TYPE_NATIVE) {
      return /*#__PURE__*/React__default["default"].createElement(DropdownNativeItem$1, props);
    }
    return /*#__PURE__*/React__default["default"].createElement(floatingMenu.FloatingMenuItem, _extends__default["default"]({}, props, {
      title: title || _willdeprecate$primary,
      description: description || _willdeprecate$secondary,
      rightContent: rightContent || _willdeprecate$tertiary
    }));
  };
  DropdownItem.displayName = DROPDOWN_ITEM_DISPLAY_NAME;
  return DropdownItem;
}();
var DropdownItem$1 = DropdownItem;
const _excluded$1 = ["children"];
const DropdownGroup = /*#__PURE__*/function () {
  const DropdownGroup = _ref => {
    let {
        children
      } = _ref,
      props = _objectWithoutProperties__default["default"](_ref, _excluded$1);
    return /*#__PURE__*/React__default["default"].createElement(floatingMenu.FloatingMenuGroup, props, children);
  };
  DropdownGroup.displayName = DROPDOWN_GROUP_DISPLAY_NAME;
  return DropdownGroup;
}();
var DropdownGroup$1 = DropdownGroup;
var _ChevronDown;
const _excluded = ["children", "className", "defaultValue", "disabled", "helper", "id", "label", "modifier", "onChange", "value"];
const DropdownNative = /*#__PURE__*/function () {
  const DropdownNative = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
        children,
        className,
        defaultValue: defaultValueProp,
        disabled,
        helper,
        id,
        label,
        modifier,
        onChange,
        value: valueProp
      } = _ref,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);
    const componentId = context.useId(id);
    const {
      value,
      defaultValue
    } = computeValueType$1({
      valueProp,
      defaultValueProp
    });
    const handleOnChange = event => {
      const newValue = event.target.value;
      if (typeof onChange === 'function') onChange(event, newValue);
    };
    const containerClassNames = classNames__default["default"](namespace, className, "".concat(formNamespace), "".concat(namespace, "--form-native"), "".concat(namespace, "--default"), {
      ["".concat(formNamespace, "--error")]: modifier === MODIFIER_ERROR,
      ["".concat(formNamespace, "--disabled")]: disabled
    });
    const options = React.Children.map(children, (item, index) => /*#__PURE__*/React.cloneElement(item, {
      index,
      type: 'native'
    }));
    return /*#__PURE__*/React__default["default"].createElement("div", {
      id: componentId,
      className: containerClassNames,
      ref: ref
    }, /*#__PURE__*/_jsx__default["default"]("label", {}, void 0, label && /*#__PURE__*/_jsx__default["default"]("span", {
      className: "".concat(formNamespace, "__label")
    }, void 0, label), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__field")
    }, void 0, /*#__PURE__*/React__default["default"].createElement("select", _extends__default["default"]({
      "aria-describedby": helper && "".concat(id, "-helper"),
      "aria-invalid": modifier === MODIFIER_ERROR,
      className: "".concat(formNamespace, "__field"),
      defaultValue: defaultValue,
      disabled: disabled,
      id: id,
      key: "andes-select",
      onChange: handleOnChange,
      value: value
    }, props), options), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__chevron"),
      "aria-hidden": true
    }, void 0, _ChevronDown || (_ChevronDown = /*#__PURE__*/_jsx__default["default"](ChevronDown20__default["default"], {}))))), helper && !disabled && /*#__PURE__*/_jsx__default["default"]("span", {
      id: "".concat(id, "-helper"),
      className: "".concat(formNamespace, "__message")
    }, void 0, helper));
  });
  DropdownNative.displayName = DROPDOWN_NATIVE_DISPLAY_NAME;
  return DropdownNative;
}();
var DropdownNative$1 = DropdownNative;
exports.Dropdown = Dropdown$1;
exports.DropdownForm = DropdownForm$1;
exports.DropdownGroup = DropdownGroup$1;
exports.DropdownItem = DropdownItem$1;
exports.DropdownNative = DropdownNative$1;
exports.DropdownNativeItem = DropdownNativeItem$1;
exports.DropdownStandalone = DropdownStandalone$1;
exports["default"] = Dropdown$1;
